(function() {

  function getSelectedValue(group) {
    const swatch = group.querySelector('.swatch-selected, [aria-checked="true"], .is-selected');
    if (swatch) {
      return (
        swatch.getAttribute('data-value') ||
        swatch.getAttribute('orig-value') ||
        swatch.textContent
      ).trim();
    }

    const checkedInput = group.querySelector('input:checked');
    if (checkedInput) {
      const parentSwatch = checkedInput.closest('.swatch-view-item, .swatch-button');
      if (parentSwatch) {
        return (
          parentSwatch.getAttribute('data-value') ||
          parentSwatch.getAttribute('orig-value') ||
          parentSwatch.textContent
        ).trim();
      }
      return checkedInput.value || '';
    }

    return '';
  }

  function applyHide(hide) {
    const walletStyleSection = document.querySelector('#swatch-option2');
    if (!walletStyleSection) return;

    if (hide) {
      walletStyleSection.classList.add('fade-out');
      walletStyleSection.classList.remove('fade-in');
    } else {
      walletStyleSection.classList.add('fade-in');
      walletStyleSection.classList.remove('fade-out');
    }
  }

  function checkAndToggle() {
    const first = document.querySelector('#swatch-option1');
    if (!first) return;

    const value = (getSelectedValue(first) || '').toLowerCase();
    console.log('[variant-conditional] detected selection:', value);

    // Hide when selection contains "magsafe"
    const hide = value.includes('magsafe');
    console.log('[variant-conditional] hide wallet style:', hide);

    applyHide(hide);
  }

  function initWalletToggle() {
    const first = document.querySelector('#swatch-option1');
    if (!first) return false;

    // Delay after click/change to ensure Shopify updates the DOM first
    first.addEventListener('click', () => setTimeout(checkAndToggle, 50));
    first.addEventListener('change', () => setTimeout(checkAndToggle, 50));

    // Initial run
    checkAndToggle();
    console.log('[variant-conditional] toggle initialized.');
    return true;
  }

  function waitForWalletToggle() {
    if (!initWalletToggle()) {
      setTimeout(waitForWalletToggle, 100);
    }
  }

  document.addEventListener('DOMContentLoaded', waitForWalletToggle);
  document.addEventListener('shopify:section:load', waitForWalletToggle);

})();
